import type { Category, Product } from "./types";

export function storefrontCategoryChildren(categories: Category[], parent: Category): Category[] {
  return categories.filter((category) => category.parentId === parent.id || category.parentSlug === parent.slug);
}

export function productMatchesStorefrontCategory(product: Pick<Product, "category" | "subcategory">, slug: string): boolean {
  return product.category === slug || product.subcategory === slug;
}
